import Helper from "@/services/Helper"

export default class ConvertQuery {
    static handle(query) {
        let q = {}
        let statuses = []

        if (query.date?.from !== undefined) {
            q = Helper.mergeObject(q, {
                "from_date": query.date.from,
            })
        }

        if (query.date?.to !== undefined) {
            q = Helper.mergeObject(q, {
                "to_date": query.date.to,
            })
        }

        if (query.users?.length > 0) {
            q = Helper.mergeObject(q, {
                "user__id": query["users"],
            })
        }

        if (query.types_commerce?.length > 0) {
            q = Helper.mergeObject(q, {
                "types_commerce_id": query.types_commerce,
            })
        }

        if (query.search !== "") {
            q = Helper.mergeObject(q, {
                "query_string": query["search"],
            })
        }

        if (query.search_full_match === true) {
            q = Helper.mergeObject(q, {
                "search_full_match": true,
            })
        }

        if (query.statuses?.published) {
            statuses.push("published")
        }

        if (query.statuses?.removed) {
            statuses.push("removed")
        }

        if (query.statuses?.scheduled) {
            statuses.push("scheduled")
        }

        if (query.statuses?.draft) {
            statuses.push("draft")
        }

        if (statuses.join(",")) {
            q = Helper.mergeObject(q, {
                "statuses": statuses.join(","),
            })
        }

        if (query.shops?.length > 0) {
            q = Helper.mergeObject(q, {
                "shops": query["shops"],
            })
        }

        if (query.categories?.length > 0) {
            q = Helper.mergeObject(q, {
                "categories": query["categories"],
            })
        }

        if (query.type_visibility !== undefined) {
            q = Helper.mergeObject(q, {
                "type_visibility": query.type_visibility,
            })
        }

        if (query.is_moderate !== undefined) {
            q = Helper.mergeObject(q, {
                "is_moderate": query.is_moderate,
            })
        }

        if (query.type_ids?.length > 0) {
            q = Helper.mergeObject(q, {
                "type_ids": query["type_ids"],
            })
        }

        if (query.promocode !== "") {
            q = Helper.mergeObject(q, {
                "promocode": query["promocode"],
            })
        }

        return Helper.mergeObject(q, {
            "limit": query["limit"],
            "offset": query["offset"],
            "channel_id": query["channel_id"],
        })
    }
}